import { useState } from 'react';
import ToggleButton from 'react-bootstrap/ToggleButton';
import { camelCase } from '../Common/Util';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { MenuDropDown } from './Common/AppUtil';

export function KPInterLinksMenu({userData, handleMenu}) {
  const [showMenu, setShowMenu] = useState(false);
  const [menuArray, setMenuArray] = useState([false,false,false,false,false,false,true,false,false,false,false,false]);
  const [birthChart, setBirthChart] = useState(false);
  const [cuspalLinksChart, setCuspalLinksChart] = useState(true);
  const [aspectsChart, setAspectsChart] = useState(false);
  const [conjoinedPlanetsChart, setConjoinedPlanetsChart] = useState(false);
  const [planetScheduleChart, setPlanetScheduleChart] = useState(false);
  const setMethod = { setBirthChart,setCuspalLinksChart, setAspectsChart,setConjoinedPlanetsChart,setPlanetScheduleChart};
  const handleShowMenu = ()=>{setShowMenu(!showMenu);}

  const handleChange=(event)=>{
    for (let key in setMethod) {
      if (setMethod.hasOwnProperty(key)) {
        setMethod[key](false);
      }
    }
    const name = event.currentTarget.id;
    const methodName = "set"+camelCase(name);
    setMethod[methodName](event.currentTarget.checked);
    const tempMenuArray = [...menuArray];
    for(var i=0;i<menuArray.length;i++) {
       tempMenuArray[i]=false;
    }
    tempMenuArray[event.currentTarget.value]=event.currentTarget.checked;
    setMenuArray(tempMenuArray);
    handleMenu(tempMenuArray);
    setShowMenu(false);
  }

  handleMenu(menuArray);

  return (
    <>
    { userData===null || userData===undefined ?<></>:
      <div class="m-0 p-0 noprint" >
        <div class="row m-0 p-0">
          <div class="col-12 m-0 p-0">
            <Navbar expand="md" className="m-0 p-0 bg-light">
              <MenuDropDown title="Cuspal Inter Link System" id={userData.id} runningId={userData.runningId}/>
              <Navbar.Toggle aria-controls="basic-navbar-nav" className="border-1 m-0 p-0 " onClick={()=>handleShowMenu()} />  
              <Navbar.Collapse id="basic-navbar-nav" className="m-0 p-0 "  in={showMenu} >
                <Nav className="m-0 p-0"  >
                  <div class="m-0 p-0">
                <ToggleButton className="m-0 me-1 p-1 border-1" id="birthChart" type="checkbox" variant="outline-transparent" checked={birthChart} value="1" onChange={(e) => handleChange(e)}>Birth Chart</ToggleButton>
                <ToggleButton className="m-0 me-1 p-1 border-1" id="cuspalLinksChart" type="checkbox" variant="outline-transparent" checked={cuspalLinksChart} value="6" onChange={(e) => handleChange(e)}>Cuspal Links</ToggleButton>
                <ToggleButton className="m-0 me-1 p-1 border-1" id="aspectsChart" type="checkbox" variant="outline-transparent" checked={aspectsChart} value="7" onChange={(e) => handleChange(e)}>Aspects</ToggleButton>
                <ToggleButton className="m-0 me-1 p-1 border-1" id="conjoinedPlanetsChart" type="checkbox" variant="outline-transparent" checked={conjoinedPlanetsChart} value="8" onChange={(e) => handleChange(e)}>Conjoints</ToggleButton>
                <ToggleButton className="m-0 me-1 p-1 border-1" id="planetScheduleChart" type="checkbox" variant="outline-transparent" checked={planetScheduleChart} value="9" onChange={(e) => handleChange(e)}>DBA</ToggleButton>
                  </div>
                </Nav>
              </Navbar.Collapse>
            </Navbar>
          </div>
        </div>
      </div>
      }
    </>
  );
}
